import { SvgIconProps } from '@traba/types'

export default function QuestionFilled({
  color = '#7A8A99',
  size = 24,
}: SvgIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <mask id="mask-question" x="0" y="0" width="24" height="24">
          {/* Base visibility */}
          <rect width="24" height="24" fill="white" />

          {/* Dot (scaled from original cx=6, cy=7.75, r=0.5) */}
          <circle cx="12" cy="15.5" r="1" fill="black" />

          {/* Question mark path (scaled 2× from original) */}
          <path
            d="M10 10V9.5C10 8.395 10.895 7.5 12 7.5C13.105 7.5 14 8.395 14 9.5V9.6213C14 10.1839 13.7765 10.7235 13.3787 11.1213L12 12.5"
            stroke="black"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
        </mask>
      </defs>

      {/* Background shape with mask */}
      <circle
        cx="12"
        cy="12"
        r="10.5"
        fill={color}
        mask="url(#mask-question)"
      />
    </svg>
  )
}
